export default __webpack_public_path__ + "static/media/Greaves of Red Ruin (nm).76dae42b.jpg";